import { useEffect, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { api } from "@/lib/api";
import { emojiFor } from "@/data/issues";

const SOUTH_CENTER = [32.8, -86.5];

export default function PledgeMap({ range = "all" }) {
  const [data, setData] = useState({ points: [], total: 0, located: 0 });
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const load = () => api.get("/admin/map", { params: { period: range } }).then(({ data }) => {
      setData(data); setPulse(true); setTimeout(() => setPulse(false), 700);
    }).catch((e) => console.warn("Map load failed", e));
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [range]);

  return (
    <div className="panel" data-testid="pledge-map-panel">
      <div className="map-head">
        <h3 style={{ margin: 0 }}>Where pledges are coming from</h3>
        <span className={`live-dot ${pulse ? "pulse" : ""}`} data-testid="map-live-indicator"><i /> Live · <b data-testid="map-located-count">{data.located}</b> of {data.total} located</span>
      </div>
      <div className="map-wrap">
        <MapContainer center={SOUTH_CENTER} zoom={5} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
            className="dark-tiles"
          />
          {data.points.map((p) => (
            <CircleMarker key={p.id} center={[p.lat, p.lng]} radius={p.source === "gps" ? 9 : 7}
              pathOptions={{ color: "#FDF71E", fillColor: p.source === "gps" ? "#E02189" : "#67DAD7", fillOpacity: 0.85, weight: 1.5 }}>
              <Popup>
                <div className="map-pop">
                  <b>{p.name}</b>{p.age ? `, ${p.age}` : ""}<br />
                  <span>{p.label || (p.source === "gps" ? "GPS location" : "")}</span><br />
                  <span>{(p.issues || []).map((i) => `${emojiFor(i)} ${i}`).join(" · ")}</span><br />
                  <span>{p.views} views · <a href={`/p/${p.slug}`} target="_blank" rel="noopener noreferrer">/p/{p.slug}</a></span>
                </div>
              </Popup>
            </CircleMarker>
          ))}
        </MapContainer>
      </div>
      <div className="map-legend"><span><i style={{ background: "#E02189" }} /> GPS pin</span><span><i style={{ background: "#67DAD7" }} /> IP-based</span><span style={{ marginLeft: "auto", opacity: .6 }}>Refreshes every 30s</span></div>
    </div>
  );
}
